export enum CardStatus {
  ACTIVE = 'active',
}

export enum CardType {
  AMERICAN_EXPRESS = 'Amex',
  DISCOVER = 'Discover',
  MASTER_CARD = 'Mastercard',
  VISA = 'Visa',
  OTHER = 'Other',
}

export interface ICard {
  id: string;
  status: CardStatus;
  createdAt: string;
  updatedAt: string;
}

export interface ICardDetails {
  id: string;
  token: string;
  userId: string;
  last4: string;
  expDate: string;
  network: CardType;
  bank: string;
  mode: string;
  owner: ICardOwner;
  sessionId: string;
  createdAt: string;
  updatedAt: string;
}

export interface IGetCardSessionRequest {
  hostUri: string;
}

export interface ICardSession {
  userId: string;
  sessionId: string;
  expiredAt: string;
  attempts: string;
  hostUri: string;
  createdAt: string;
  updatedAt: string;
}

export interface ICardOwner {
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
}

export interface ITokenizeCardRequest {
  cardNumber?: string;
  cvv?: string;
  expDate?: string;
  last4?: string;
  network?: string;
  sessionId?: string;
  userId: string;
  owner?: ICardOwner;
}
